import axios from 'axios';
import { parse, format } from 'date-fns';
import React, { FC, useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import useSWR from 'swr';

import Icon from '../../Icon';
import VideoModal from './VideoModal';
import Text from '../../Typography/Text';

import { IVideo } from './interfaces';

import './styles.scss';

// fetcher
const fetcher = (url: string) => {
  const origin = encodeURI(window.location.origin);
  return axios.get(`https://www.youtube.com/oembed?url=${url}${origin}`)
    .then(({ data }: any) => data);
};

// news item
const Video: FC<IVideo> = ({
  date,
  lang,
  title,
  youtube_url
}) => {
  const [ open, setOpen ] = useState<boolean>(false);
  const [ duration, setDuration ] = useState<any>(0);

  const dateObject = new Date(date);
  const dateObjectUpdated = dateObject.setDate(dateObject.getDate() + 1)

  const dataFormat = parse(format(dateObjectUpdated, 'yyyy-MM-dd'), 'yyyy-MM-dd', new Date());

  // element
  const element: any = document.getElementById('search');

  // data
  const { data } = useSWR(`${youtube_url}&format=json&origin=`, fetcher);

  // format time
  const formatTime = useCallback((time: number) => {
    let hrs = ~~(time / 3600);
    let mins = ~~((time % 3600) / 60);
    let secs = ~~time % 60;

    let ret = '';

    if (hrs > 0) {
      ret += '' + hrs + ':' + (mins < 10 ? '0' : '');
    }

    ret += '' + mins + ':' + (secs < 10 ? '0' : '');
    ret += '' + secs;

    return ret;
  }, []);  

  // get date
  const getDate = useCallback(() => {
    const value = lang !== 'en' ? format(dataFormat, 'dd/MM/yyyy') : format(dataFormat, 'MM/dd/yyyy');

    return value;
  }, [ dataFormat, lang ]);

  // render
  return (
    <div
      className="video"
      onClick={() => setOpen(!open)}>
      <>
        <div className="video--image">
          <Icon className="icon" icon="icon-video" />
          {duration > 0 && <span className="duration">{formatTime(duration)}</span>}

          <img src={data?.thumbnail_url} alt={title} />
        </div>

        <div className="video--container">
          <div className="video--container--title">
            <p className="date">{getDate()}</p>
          </div>

          <Text attrs={{ className: 'description '}} text={title} type="danger" />
        </div>

        {open && createPortal(<VideoModal
          url={youtube_url}
          onDuration={setDuration}
          toggle={() => setOpen(!open)} />, element)}
      </>
    </div>
  );
};

export default Video;